import FizConfig from "../FizConfig.ts";
import {addParams} from "../lib/url.ts";

/*
Function: getPictureUrl(pictureUri,width,height): string
Add expected width/height parameters to a picture URI

Parameters:
  pictureUri - string, picture URI received from server
  width - number, optional, the expected width for picture display,
    in pixels, defaults to DEFAULT_PICTURE_WIDTH
  height - number, optional, the expected height for picture display,
    in pixels, defaults to DEFAULT_PICTURE_HEIGHT

Returns:
  string, a picture URL for the location of the given picture resized to
  the expected dimensions
*/
export function getPictureUrl(picture :string,width :number,height :number){
  if(!picture){
    return null;
  }
  return addParams(picture, {w:width,h:height,s:"c"});
}

export function getDefaultUrl(name :string, color :string){
  name = name.trim();
  if(name.length>1){
    name = name.substring(0,1).toUpperCase()+name.substring(1,2);
  }else if(name.length===1){
    name = name.toUpperCase();
  }else{
    name = '?';
  }

  return addParams(FizConfig.API_BASE_URL+"avatardefault", {co:color,fn:name});
}